<template>
<div class="login_content">
  <div class="login_header">
    <img src="/upload/dmsm/软件标题.png" class="login_text" />
  </div>
  <div class="login_main">
    <a-form
    :model="loginInfo"
    autocomplete="off"
    @submit="loginSubmit"
    class="formInfo"
  >
    <div class="input_info">
      
    <a-form-item
      name="userName"
      :rules="[{ required: true, message: '账户不能为空' }]"
    > 
     <img src="@/style/img/dl_zh.png" class="loginImg"/>
      <label>账户</label>
      <a-input v-model:value="loginInfo.userName" name="账户" placeholder="请输入账号"/>
    </a-form-item>
    </div>
    <div class="input_info">
     <a-form-item
      name="password"
      :rules="[{ required: true, message: '密码不能为空' }]"
    > 
    <img src="@/style/img/dl_mm.png" class="loginImg"/>
      <label>密码</label>
      <a-input type="password" v-model:value="loginInfo.password" name="密码" placeholder="请输入密码" />
    </a-form-item>
    </div>
    <a-form-item :wrapper-col="{ offset: 8, span: 16 }">
      <a-button type="primary" html-type="submit" class="submitBtn" >登录</a-button>
    </a-form-item>
  </a-form>
</div>
  </div>
     
</template>

<script>
import {login,getUserInfo,getDictDataByDictType} from '../api/login'
import config from '@/utils/config'
 export default {
    data() {
        return {
            loginInfo: {
              userName :'', 
              password :'',
          },
        }
    },
    mounted() {
    },
    methods : {
       //获取用户类型
       getUserType(type) {
            getDictDataByDictType().then(res => {
              if(res.data && res.data.length > 0) {
                let obj = {}
                res.data.forEach(element => {
                  if(element.dictLabel) {
                    obj[element.dictLabel] = element.dictValue
                  }
                });
                if(obj[type] == '变电站用户' )  {
                  this.$router.push({
                    path: config.indexURL
                  })
                }
                else {
                  this.$router.push({
                    path: '/map'
                  })
                }
              }
              
            })
          },
         loginSubmit(e) {
            e.preventDefault();
              login({
                username : this.loginInfo.userName,
                password : this.loginInfo.password,
              }).then(res => {
                if(res.success) {
                  localStorage.setItem('token',res.data)
                  this.getUserInfo()
                 
                }
                else {
                  this.$message.info("账号或者密码错误");
                }
                
              }).catch((err) => {
                this.$message.info("登录失败",err);
              })
          },
          getUserInfo() {
            getUserInfo().then(res => {
              if(res.success && res.data) {
                localStorage.setItem('loginInfo',JSON.stringify(res.data));
                if(res.data.userType) {
                  this.getUserType(res.data.userType)
                }
               
              }
            })
          }
  }
 }
</script>

<style scoped>
.login_content {
  background: url(../style/img/dl_bg.jpg) no-repeat;
  background-position: center;
  background-size: 100% 100%;
  height: 100vh;
  width: 100%;
}
.login_header {
  background: url(../style/img/dl_top.png) no-repeat;
  background-position: center;
  background-size: 100% 100%;
  height: 86px;
  width:100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login_text {
  display: inline-block;
  margin: auto;
  width: 30vw;
}
.login_main {
  position:absolute;
  top:50%;
  right:20%;
  transform: translateY(-50%);
  height : 50vh;
  width : 30vw;
  background: url(../style/img/dl_bk.jpg.png) no-repeat;
  background-position: center;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.formInfo {
  /* width:80%; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.loginImg {
  width:1vw;
  /* height: 2.4vh;; */
}
.input_info {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
    width:20vw;
    gap : 0.6vw;
}
.submitBtn {
  background: url(../style/img/dl_btn.png) no-repeat;
  background-position: center;
  background-size: 100% 100%;

}
.ant-form label {
  width:3vw;
}
</style>